export default __webpack_public_path__ + "static/media/zeroGuide4.0ff31374.png";